import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { softwarePolicyConflictsPageEntryPoint } from '@jira/spa-apps__guided-autonomy-remediation/src/softwarePolicyConflictsPageEntryPoint.entrypoint.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { softwareProjectLayout } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { projectSettingsSoftwarePolicyConflictsRoute } from '@jira/router-routes__project-settings-product-routes-software-routes/src/projectSettingsSoftwarePolicyConflictsRoute.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import { getSettingsNavigationResources } from './ui/project-settings/product-routes/common/index.tsx';

const softwarePolicyConflictsPage = createPageEntryPoint({
	main: softwarePolicyConflictsPageEntryPoint,
});

export const projectSettingsSoftwarePolicyConflictsRouteEntry: Route = createEntry(
	projectSettingsSoftwarePolicyConflictsRoute,
	() => ({
		group: 'project-settings-software',
		ufoName: 'project-settings.policy-conflicts.jsw',
		layout: softwareProjectLayout,
		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},
		resources: [...getSettingsNavigationResources()],
		entryPoint: () =>
			fg('guided_autonomy_remediation') ? softwarePolicyConflictsPage : notFoundPageEntrypoint,
		meta: {
			reporting: {
				id: 'project-settings.policy-conflicts.jsw',
				packageName: 'jiraSpaAppsGuidedAutonomyRemediation',
				teamName: 'a4t-tanuki',
			},
		},
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
